import React from 'react'
import Navbar from '../components/Navbar'
import MainBlogSection from './MainBlogSection'
import Footer from '../components/Footer'
export default function Blog() {
  return (
    <div>
      <Navbar/>
<MainBlogSection/>
<Footer/>
    </div>
  )
}
